import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';

import useStorage from '../../../../../../hooks/useStorage';
import useComponentMounted from '../../../../../../hooks/useComponentMounted';
import { attachmentShape } from '../../../../../../utils/attachments';
import AttachmentError from '../AttachmentError';

import { AttachmentGenericWrapper } from './styles';

const GenericAttachment = ({
  attachment,
  AttachmentComponent,
}) => {
  const {
    getDownloadUrlFromStoragePath,
  } = useStorage();
  const [attachmentDownloadUrl, setAttachmentDownloadUrl] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [showError, setShowError] = useState(false);

  const isComponentMountedRef = useComponentMounted();

  useEffect(() => {
    const getAttachmentLocalUrl = async () => {
      try {
        const downloadUrl = await getDownloadUrlFromStoragePath(attachment);
        setAttachmentDownloadUrl(downloadUrl);
      } catch (error) {
        setShowError(true);
      } finally {
        setIsLoading(false);
      }
    };
    getAttachmentLocalUrl();
  }, [
    attachment,
    getDownloadUrlFromStoragePath,
    isComponentMountedRef,
  ]);

  return (
    <AttachmentGenericWrapper>
      {isLoading && <CircularProgress name="crescent" />}
      {!isLoading && (
        showError
          ? <AttachmentError />
          : <AttachmentComponent attachmentData={attachment} assetLocalUrl={attachmentDownloadUrl} />
      )}
    </AttachmentGenericWrapper>
  );
};

GenericAttachment.propTypes = {
  attachment: attachmentShape,
  AttachmentComponent: PropTypes.any.isRequired,
};

GenericAttachment.defaultProps = {
  attachment: {},
};

export default GenericAttachment;
